import React, { Component } from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import SpecialNFTCheck from "../Components/SpecialNFTCheck"

class ValidateNFT extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <SpecialNFTCheck />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default ValidateNFT
